import PropTypes from 'prop-types';

import './ContextMenuRow.scss';

const propTypes = {
  children: PropTypes.node,
};

const defaultProps = {
  children: <span />,
};

function ContextMenuRow({ children }) {
  return <div className="ContextMenuRow">{children}</div>;
}

ContextMenuRow.propTypes = propTypes;
ContextMenuRow.defaultProps = defaultProps;

export default ContextMenuRow;
